import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Logs } from 'Pages/advertisement/models'

export type LogsState = {
	log: Logs | null
	logAdriver: Logs | null
}

export const logInitialState: LogsState = {
	log: null,
	logAdriver: null,
}

export namespace logNS {
	export type GetLogs = PayloadAction<number>
	export type SetLogs = PayloadAction<Logs>
	export type SetLogsAdriver = PayloadAction<Logs>
}

export const logSlice = createSlice({
	name: 'log',
	initialState: logInitialState,
	reducers: {
		getLogs: (state, action: logNS.GetLogs) => {},
		setLogs: (state, action: logNS.SetLogs) => {
			state.log = action.payload
		},
		setLogsAdriver: (state, action: logNS.SetLogsAdriver) => {
			state.logAdriver = action.payload
		},
	},
})
